module.exports = __webpack_public_path__ + "static/media/PlanActivar.b28f8c06.jpg";